import React, {useEffect, useState, useRef} from 'react';
import {useRecoilState, useRecoilValue, useSetRecoilState} from 'recoil';

import {
  AddressSelectorList,
  CommunityAddress1,
  CommunityAddress2,
  CommunityAddressTxt,
  CommunityListArgs,
  isOpenAddressSelector,
} from '../../../store';
import FilterModalHeader from '../../common/FilterModal/FilterModalHeader';
import styles from './styles.module.scss';

interface Props {
  addressList: Address[];
}

export default function AddressSelector({addressList}: Props) {
  const [isOpen, setIsOpen] = useRecoilState(isOpenAddressSelector);
  const [selectedAddress1, setSelectedAddress1] = useState<string>('인기 지역');
  const [selectedAddress2, setSelectedAddress2] = useState<string>('');
  const setAddress1 = useSetRecoilState(CommunityAddress1);
  const setAddress2 = useSetRecoilState(CommunityAddress2);
  const setAddressTxt = useSetRecoilState(CommunityAddressTxt);
  const [selectedAddressType, setSelectedAddressType] = useState<1 | 2 | 3>(1);
  const addressGroups = useRecoilValue(AddressSelectorList);
  const [args, setArgs] = useRecoilState(CommunityListArgs);

  const close = () => {
    setIsOpen(false);
    initFn();
  };
  const initFn = () => {
    setSelectedAddress1('인기 지역');
    setSelectedAddress2('');
    setSelectedAddressType(1);
    setAddress1('');
    setAddress2('');
    setAddressTxt('지역 전체');
    setArgs({
      address1: '',
      address2: '',
      page: 0,
    });
    setIsOpen(false);
  };
  const findAddress2 = (add1Arr: number[]) => {
    let add2Arr: number[] = [];
    for (let i = 0, max = add1Arr.length; i < max; i++) {
      const add1 = addressList.find(al => al.id === add1Arr[i]);
      add2Arr = [...add2Arr, ...(add1?.child?.map(c => c.id) || [])];
    }
    return add2Arr;
  };
  const complete = () => {
    let address1 = '';
    let address2 = '';
    const group = addressGroups.find(g => g.groupName === selectedAddress1);
    const innerAddressList =
      group?.addressList.find(al => al.txt === selectedAddress2)?.address2 ||
      [];

    switch (selectedAddressType) {
      case 1:
        address1 = group?.address1.join(',') || '';
        address2 =
          innerAddressList.length > 0 && innerAddressList[0] === 0
            ? findAddress2(group?.address1 || []).join(',')
            : group?.addressList
                .find(al => al.txt === selectedAddress2)
                ?.address2.join(',') || '';
        setAddress1(address1);
        setAddress2(address2);
        break;
      case 2:
        address1 =
          group?.addressList
            .find(al => al.txt === selectedAddress2)
            ?.address2.join(',') || '';

        setAddress1(address1);
        setAddress2('');
        break;
      case 3:
        address1 = 'online';
        setAddress1(address1);
        setAddress2('');
        break;
    }
    setArgs({
      ...args,
      address1,
      address2,
      page: 0,
    });
    setAddressTxt(`${selectedAddress2}`);
    setIsOpen(false);
  };
  const clickAddress1 = (txt: string, type: 1 | 2 | 3) => {
    setSelectedAddress1(txt);
    setSelectedAddressType(type);
  };
  const clickAddress2 = (txt: string) => {
    setSelectedAddress2(txt);
  };

  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // document.addEventListener('mousedown', handleClickOutside);
    document.querySelector('.addressGroup1')?.addEventListener('scroll', () => {
      console.log('scrolled');
    });
    document
      .querySelector('.addressGroup1')
      ?.addEventListener('touchmove', () => {
        console.log('in touch move');
      });
    return () => {
      // document.removeEventListener('mousedown', handleClickOutside);
      document
        .querySelector('.addressGroup1')
        ?.removeEventListener('scroll', () => {
          console.log('scrolled');
        });
    };
  }, []);

  return (
    <div className={`modal-wrapper ${isOpen ? '' : styles.hide}`}>
      <div
        className={`modal-contents category ${styles.address}`}
        ref={wrapperRef}>
        <FilterModalHeader
          txt={'지역 선택'}
          close={() => close()}
          hasInit={true}
          withPadding={true}
          initFn={() => initFn()}
          fnTxt="초기화"
        />
        {isOpen && (
          <div className={`category-modal-body ${styles.address_selector}`}>
            <div className={`${styles.address1_group} addressGroup1`}>
              {addressGroups.map((group, idx) => {
                return (
                  <div
                    key={`address_group1_${idx}`}
                    className={
                      selectedAddress1 === group.groupName
                        ? `${styles.toggled}`
                        : ''
                    }
                    onClick={() =>
                      clickAddress1(group.groupName, group.addressType)
                    }>
                    {group.groupName}
                  </div>
                );
              })}
            </div>
            <div className={styles.address2_group}>
              <ul>
                {selectedAddress1 &&
                  selectedAddress1.length > 0 &&
                  addressGroups
                    .find(ag => ag.groupName === selectedAddress1)
                    ?.addressList.map((o, i) => {
                      return (
                        <li
                          key={`address_group2_${i}`}
                          className={selectedAddress2 === o.txt ? 'active' : ''}
                          onClick={() => clickAddress2(o.txt)}>
                          {o.txt}
                        </li>
                      );
                    })}
              </ul>
            </div>
          </div>
        )}
        <div className={`filter-modal-footer ${styles.address_footer}`}>
          <button
            className="modal btn black-filled"
            disabled={
              !(selectedAddress1.length > 0 && selectedAddress2.length > 0)
            }
            onClick={() => complete()}
            style={{
              background: !(
                selectedAddress1.length > 0 && selectedAddress2.length > 0
              )
                ? '#E9E7EC'
                : '#000',
            }}>
            선택 완료
          </button>
          <button className="modal btn empty" onClick={() => close()}>
            취소
          </button>
        </div>
      </div>
    </div>
  );
}
